import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { textColor } from "../../../utils/commonstyle";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { getKycDetails, postKycDetails } from "../../../redux/slice/ledgerSlice";
import { AppDispatch } from "../../../redux/store";

const IndividualInVerify = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { instance } = useMsal();
    const [kycDetails, setKycdetails] = useState<any>();
    const { loginInvestorId } = useSelector((state: any) => state.user);
    const account: any = instance.getActiveAccount();

    const handleKycDetails = async () => {
        if (!loginInvestorId) return;
        try {
            const kycDetailsData = await dispatch(getKycDetails(loginInvestorId)).unwrap();
            setKycdetails(kycDetailsData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        let delay = 5 * 60 * 1000; // Start with 5 minutes 5 * 60 * 1000
        let elapsedTime = 0;
        const maxDuration = 80 * 60 * 1000; // 2 hours
        let timeoutId: NodeJS.Timeout;

        const fetchWithBackoff = () => {
            if (elapsedTime >= maxDuration) return; // Stop after 2 hours
            console.log(`Calling API after ${delay / 60000} minutes`);
            handleKycDetails();
            elapsedTime += delay;
            timeoutId = setTimeout(fetchWithBackoff, delay);
            delay *= 2; // Double the delay (5m → 10m → 20m → 40m → 80m)
        };
        timeoutId = setTimeout(fetchWithBackoff, delay);

        return () => clearTimeout(timeoutId); // Cleanup on unmount
    }, []);

    const handlePostKyc = async () => {
        const response = await dispatch(postKycDetails(loginInvestorId)).unwrap();
        if (response.statusCode === 400) {
            navigate("/kyc-kyb/identity-verification", {
                state: { loginInvestorId },
            });
            return;
        }
    }

    useEffect(() => {
        const verificationStatus = kycDetails?.body[0]?.verification_status
        if (kycDetails?.statusCode === 200 && verificationStatus === "passed") {
            navigate("/kyc-kyb/bidding-agreement");
        }
        else if (typeof kycDetails?.body === "string" && kycDetails?.statusCode === 200) {
            handlePostKyc()
        }
    }, [kycDetails]);

    return (
        <Box
            sx={{
                maxWidth: { xs: "90%", md: "45%" },
                mx: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: { xs: "80vh", md: "65vh" },
                boxShadow: 1,
                bgcolor: "background.paper",
                textAlign: "center",
                p: 4,
                mt: 1,
            }}
            data-testid="identity-verification-container"
        >
            <Typography
                variant="h5"
                component="h5"
                sx={{
                    fontWeight: 600,
                    fontSize: { xs: "1.25rem", md: "26px" },
                    color: "text.primary",
                    mb: 2,
                }}
                data-testid="verification-title"
            >
                User Identity Verification In Progress
            </Typography>

            <Typography
                variant="body1"
                sx={{
                    fontSize: { xs: "0.875rem", md: "1.15rem" },
                    color: textColor.fontColor,
                }}
                data-testid="verification-message"
            >
                Your User Identity Verification is in progress.
            </Typography>

            <Typography
                variant="body2"
                sx={{
                    fontSize: { xs: "0.875rem", md: "1.15rem" },
                    color: textColor.fontColor,
                }}
                data-testid="verification-notification"
            >
                We will notify you via email at
                <Typography
                    component="span"
                    sx={{
                        color: textColor.primaryColor,
                        mx: 0.5,
                        fontSize: { xs: "0.875rem", md: "1.15rem" }
                    }}
                    data-testid="email-address"
                >
                    {account?.idTokenClaims?.email || account?.idTokenClaims?.emails || sessionStorage.getItem('impersonateEmail') }
                </Typography>
                once it is complete.
            </Typography>
        </Box>
    );
};

export default IndividualInVerify;
